<!-- A popup dialog to select a different brand -->
<app-choose-brand [displayBrandDialog] = "openBrandSelectionDialog" (chooseBrandEvent)="chooseBrand($event)"></app-choose-brand>

<!--- Generic header, inclusing current brand andd a button to select another brand -->

<div class="grid">
    <div class="col-6">
        <app-brand-admin-header></app-brand-admin-header>
    </div>
    <div class="col-1">
        <button pButton type="button" label="Brand" icon="pi pi-sitemap" iconPos="left" (click)="onChooseBrandClick($event)"  
             class="p-button-raised p-button-rounded"  [disabled]="isDetailsShown">
         </button>
    </div>  
    <app-side-menu  [parentForm] = "currentForm"></app-side-menu>
</div> 

<!--   -->

 <!-- Grid with all brand config properties based on the specified selection criteria  -->

<div class="grid w-full">

    @if(isListShown && showItem()) {
        <!-- <div @flyInOut class="col-9  side-list-content-data"> -->
        <div class="col-11 panel" animate.enter="fly-in" animate.leave="fly-out">
            <p-card header="List of Brand Configuration Properties" subheader="" class="ui-card-light" >

                <p-table #dt [columns]="cols" [value]="brandConfigProperties" selectionMode="single" 
                        sortMode="multiple"  [paginator]="true" [rows]="15" class="wal-table" >
                    <ng-template pTemplate="caption">
                        List of Brand Config Properties
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            @for (col of columns; track col.field) {
                                <th [pSortableColumn]="col.field"
                                    [style.display]="col.display"
                                    [style.width]="col.width">
                                    {{ col.header }}
                                    <p-sortIcon [field]="col.field"></p-sortIcon>
                                </th>
                            }
                            <th [ngStyle]="{'width': 'table-cell', 'display': '8%'}">
                            </th>
                        </tr>
                        <tr>
                            @for (col of columns; track col.field) {
                                <th [style.width]="col.width" [style.display]="col.display">
                                    @switch (col.field) {
                                        @case ('propertyName') {
                                            <input pInputText type="text" [style.width]="'100%'"
                                                (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                            />
                                        }
                                        @case ('propertyValue') {
                                            <input pInputText type="text" [style.width]="'100%'"
                                                (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                            />
                                        }
                                        @default {
                                        }
                                    }
                                </th>
                            }                        
                            <th></th>
                        </tr>  
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData">
                            @for (col of columns; track col.field) {
                                <td [style.width]="col.width" [style.display]="col.display">
                                    {{ rowData[col.field] }}
                                </td>
                            }
                            <td style="text-align:center">
                                <button pButton type="button" icon="pi pi-pencil" [style]="{'width':'20px', 'height':'20px', 'margin-right':'2px'}"  
                                    data-toggle="tooltip" data-placement="top" title="Modify brand configuration property" 
                                    class="ui-button-info" (click)="onRowEdit(rowData)">
                                </button>
                                <button pButton type="button" icon="pi pi-times" [style]="{'width':'20px', 'height':'20px', 'margin-right':'2px'}"  
                                    data-toggle="tooltip" data-placement="top" title="Delete brand configuration property" 
                                    class="ui-button-danger" (click)="onRowDelete(rowData)" *ngIf="isSubmitShown" >
                                </button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary" let-rowData>
                        @if(isSubmitShown) {
                            <div class="mt-2 text-left">
                                <p-button type="submit" label="Add" 
                                    styleClass="p-button-info wal-info p-button-rounded" 
                                    (click)="showDialogToAdd()">
                                </p-button>
                            </div>
                        }                    
                    </ng-template>    
            </p-table> 
        
                <p-footer>
                    <mat-icon class="nav-caption wal-center">list_all</mat-icon>
                </p-footer>
            </p-card>
        </div>
    }

<!-- Brand Config Details dialog -->

    @if(isDetailsShown && showItem()) {
        <!-- <div @flyInOut class="col-6 side-list-content-data"> -->
        <div class="col-6 panel" animate.enter="fly-in" animate.leave="fly-out">
            <p-card header="Brand Configuration Property Details" subheader="" class="ui-card-light" >
            
                <form [formGroup]="userform" (ngSubmit)="onSubmit(userform.value)">
        
                    <div>


                        <div class="field grid">
                            <div class="col-1"></div>
                                <label for="brandConfigPropertyId" class="col-fixed label" style="width: 17em">Brand Config Property Id:</label>
                                <div class="col">
                                <input pInputText id="brandConfigPropertyId" type="text" formControlName="brandConfigPropertyId" readonly="true" 
                                    autofocus style="width: 10em"/> 
                                </div>
                        </div>   

                        <div class="field grid">
                            <div class="col-1"></div>
                                <label for="enabled" class="col-fixed label" style="width: 17em">Enabled:</label>
                                <div class="col">
                                    <p-checkbox formControlName="enabled" id="enabled" [binary]="true"></p-checkbox>
                                </div>
                        </div>   


                        <div class="field grid">
                            <div class="col-1"></div>
                                <label for="propertyName" class="col-fixed label" style="width: 17em">Property Name:</label>
                            <div class="col">
                                <p-select id ="propertyName" [options]="configProperties" formControlName="propertyName"
                                    [filter]="true" placeholder="Select property" [editable]="false" [style]="{'width': '80%'}"
                                    (onChange)="onConfigPropertyChange()">
                                </p-select>
                            </div>

                            </div>

                        <div class="field grid">
                            <div class="col-1"></div>
                                <label for="propertyDescription" class="col-fixed label" style="width: 17em">Property Description:</label>
                            <div class="col">
                                <textarea [rows]="1" [cols]="30" pTextarea [autoResize]="autoResize" id="propertyDescription" 
                                formControlName="propertyDescription" style="width: 100%;" readonly="true"></textarea>
                            </div>
                        </div>

                        <div class="field grid">
                            <div class="col-1"></div>
                                <label for="propertyValue" class="col-fixed label" style="width: 17em">Property Value:</label>
                            <div class="col">
                                <textarea [rows]="5" [cols]="30" pTextarea [autoResize]="autoResize" id="propertyValue" 
                                formControlName="propertyValue" style="width: 100%;"></textarea>
                            </div>
                        </div>

                        <div class="field grid">
                            <div class="col-1"></div>
                                <label for="createDate" class="col-fixed label" style="width: 17em">Create Date:</label>
                            <div class="col">
                                <input pInputText id="createDate" formControlName="createDate" readonly="true" />
                            </div>
                        </div>

                        <div class="field grid">
                            <div class="col-1"></div>
                                <label for="lastUpdateDate" class="col-fixed label" style="width: 17em">Last Update Date:</label>
                            <div class="col">
                                <input pInputText id="lastUpdateDate" formControlName="lastUpdateDate" readonly="true"/>
                            </div>
                        </div>

                        <div class="col-12">
                            <div  class="col-2" class="row container-fluid"  id="divshow">
                                <p-button type="submit" label="Submit" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" [disabled]="!userform.valid" *ngIf="isSubmitShown" ></p-button>
                                <p-button type="button" label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="cancelDetails()"></p-button>
                            </div> 
                            @if(!isSubmitShown) {
                                <div class="col-10">
                                    <mat-label>{{resultMsg}}</mat-label>
                                </div>
                            }
                        </div>
                                
                    </div>
                </form>
        
                <p-footer>
                    <mat-icon class="nav-caption wal-center">view_compact</mat-icon>
                </p-footer>
            </p-card>
        
        </div>
    }


</div>

<!-- Brand Config Details dialog -->

<p-confirmDialog appendTo="body" key="brand-config-properties"></p-confirmDialog>
